import * as React from 'react';

const NotificationAiBotIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={'100%'}
    height={'100%'}
    viewBox="0 0 55 55">
    <path
      fill="url(#notificationAiBotIconColor1)"
      d="M27.267 11.48a1.459 1.459 0 0 1 1.458 1.458v1.455H33.1a4.375 4.375 0 0 1 4.374 4.374V24.6a4.374 4.374 0 0 1-4.374 4.374v.425l5.066 2.657c.328.174.576.478.69.844.116.366.088.766-.077 1.11-.116.24-.293.442-.51.584-.22.141-.472.217-.728.218a1.247 1.247 0 0 1-.626-.16l-3.816-2.002v7.995a1.459 1.459 0 1 1-2.916 0v-2.921h-5.832v2.922a1.46 1.46 0 0 1-2.917 0v-7.978l-3.804 1.983c-.193.108-.41.163-.628.16-.259 0-.511-.076-.731-.217a1.438 1.438 0 0 1-.514-.584 1.516 1.516 0 0 1-.079-1.11c.115-.366.365-.67.695-.844l5.061-2.64v-.443a4.373 4.373 0 0 1-4.373-4.373v-5.833a4.374 4.374 0 0 1 4.374-4.374h4.374v-1.455a1.46 1.46 0 0 1 1.458-1.458Zm-2.916 23.328h5.832v-5.832h-5.832v5.832Zm-2.916-17.5a1.46 1.46 0 0 0-1.458 1.459V24.6a1.457 1.457 0 0 0 1.458 1.458H33.1a1.458 1.458 0 0 0 1.458-1.458v-5.833a1.458 1.458 0 0 0-1.458-1.458H21.435Zm8.75 2.918a1.464 1.464 0 0 1 1.034 2.5c-.071.066-.15.124-.233.174a.817.817 0 0 1-.248.131.877.877 0 0 1-.277.088l-.277.03a1.46 1.46 0 0 1-.56-2.812c.177-.074.368-.111.56-.111Zm-6.49.101c.293-.134.62-.169.933-.098.097.014.191.044.278.088.09.03.173.074.248.131l.233.175a1.46 1.46 0 0 1-.2 2.287c-.248.162-.54.243-.835.235a1.531 1.531 0 0 1-1.035-.422 1.458 1.458 0 0 1 .379-2.396Z"
    />
    <path
      fill="url(#notificationAiBotIconColor2)"
      d="M42.104 7.678a.337.337 0 0 1 .632 0l.888 2.402a.337.337 0 0 0 .2.199l2.401.888a.337.337 0 0 1 0 .632l-2.401.889a.337.337 0 0 0-.2.199l-.888 2.402a.337.337 0 0 1-.632 0l-.889-2.402a.337.337 0 0 0-.199-.199l-2.401-.889a.337.337 0 0 1 0-.632l2.401-.888a.337.337 0 0 0 .2-.2l.888-2.4Z"
    />
    <path
      fill="url(#notificationAiBotIconColor3)"
      d="M34.733 43.397a.337.337 0 0 1 .632 0l.23.62a.337.337 0 0 0 .198.199l.62.23a.337.337 0 0 1 0 .631l-.62.23a.337.337 0 0 0-.199.198l-.229.62a.337.337 0 0 1-.632 0l-.23-.62a.337.337 0 0 0-.198-.199l-.62-.229a.337.337 0 0 1 0-.632l.62-.23a.337.337 0 0 0 .199-.198l.229-.62Z"
    />
    <path
      fill="url(#notificationAiBotIconColor4)"
      d="M11.408 36.682a.337.337 0 0 1 .632 0l.468 1.265a.337.337 0 0 0 .199.2l1.265.467a.337.337 0 0 1 0 .632l-1.265.468a.337.337 0 0 0-.2.2l-.467 1.264a.337.337 0 0 1-.632 0l-.468-1.265a.337.337 0 0 0-.2-.199l-1.264-.468a.337.337 0 0 1 0-.632l1.265-.468a.337.337 0 0 0 .199-.199l.468-1.265Z"
    />
    <defs>
      <linearGradient
        id="notificationAiBotIconColor1"
        x1={37.315}
        x2={13.567}
        y1={11.48}
        y2={35.832}
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#2961FA" />
        <stop offset={1} stopColor="#CB0040" />
      </linearGradient>
      <linearGradient
        id="notificationAiBotIconColor2"
        x1={46.435}
        x2={39.515}
        y1={6.824}
        y2={16.142}
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#2961FA" />
        <stop offset={1} stopColor="#CB0040" />
      </linearGradient>
      <linearGradient
        id="notificationAiBotIconColor3"
        x1={36.96}
        x2={33.666}
        y1={42.543}
        y2={46.979}
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#2961FA" />
        <stop offset={1} stopColor="#CB0040" />
      </linearGradient>
      <linearGradient
        id="notificationAiBotIconColor4"
        x1={14.397}
        x2={9.79}
        y1={35.828}
        y2={42.032}
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#2961FA" />
        <stop offset={1} stopColor="#CB0040" />
      </linearGradient>
    </defs>
  </svg>
);

export default NotificationAiBotIcon;
